import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Form, InputGroup } from 'react-bootstrap';
import { Visibility, VisibilityOff } from '@mui/icons-material';

const InputPassword = props => {
  const [showPassword, setShowPassword] = useState(props?.type === 'text');
  const iconProps = {
    color: '#02bdbd',
    size: '1.5rem',
    cursor: 'pointer',
  };

  return (
    <InputGroup>
      <Form.Control
        data-testid="inputPassword"
        {...props}
        type={showPassword ? 'text' : 'password'}
      />
      <InputGroup.Text
        style={{ height: '38px' }}
        onClick={() => setShowPassword(prev => !prev)}
      >
        {showPassword ? (
          <Visibility data-testid="passwordVisible" {...iconProps} />
        ) : (
          <VisibilityOff data-testid="passwordHidden" {...iconProps} />
        )}
      </InputGroup.Text>
    </InputGroup>
  );
};

InputPassword.defaultProps = {
  type: 'password',
};

InputPassword.propTypes = {
  type: PropTypes.string,
};

export default InputPassword;
